import { MARK_TYPE } from 'config/constants/preview'
import { ClipCreatorMarkType } from 'types/preview'

export type MarkerCommandMarkType = Exclude<ClipCreatorMarkType, 'clearInOutPoints' | 'drag'>

export type MarkerPoints = {
  markIn: null | number,
  markOut: null | number,
}

export type MarkerDissolve = {
  isAttachedTo(assetId: string, side?: string): boolean
} | null | undefined

export type MarkerCommand =
  | { kind: 'single', point: number }
  | { kind: 'collapse', markers: MarkerPoints }

type DissolveGuardArgs = {
  dissolve: MarkerDissolve,
  assetId: null | string,
  markType: MarkerCommandMarkType,
}

export const isMarkerBlockedByDissolve = ({ dissolve, assetId, markType }: DissolveGuardArgs): boolean => {
  if (!dissolve || !assetId) return false
  const attachedToRight = dissolve.isAttachedTo(assetId, 'right')
  const attachedToLeft = dissolve.isAttachedTo(assetId, 'left')
  if (attachedToRight && markType === MARK_TYPE.IN) return true
  if (attachedToLeft && markType === MARK_TYPE.OUT) return true
  return false
}

export const getMarkerDiff = (
  markType: MarkerCommandMarkType,
  point: number,
  markers: MarkerPoints,
  fallbackDuration: number
): number => (
  markType === MARK_TYPE.IN
    ? (markers.markOut || fallbackDuration) - point
    : point - (markers.markIn || 0)
)

export const isCollapsedMarkerRange = (diff: number, minClipDuration: number): boolean => (
  diff === 0 || diff < minClipDuration
)

export const resolvePlainMarkerCommand = ({
  markType,
  point,
  markers,
  duration,
  minClipDuration,
}: {
  markType: MarkerCommandMarkType,
  point: number,
  markers: MarkerPoints,
  duration: number,
  minClipDuration: number,
}): MarkerCommand => {
  const diff = getMarkerDiff(markType, point, markers, duration)

  if (diff >= minClipDuration) {
    return { kind: 'single', point }
  }

  return {
    kind: 'collapse',
    markers: markType === MARK_TYPE.IN
      ? { markIn: point, markOut: null }
      : { markIn: null, markOut: point },
  }
}
